import { useRouter } from 'next/router';

export const useActiveLink = (url: string) => {
  const { route } = useRouter();
  return url === route;
};
